import React, {PropTypes} from "react";
import {BootstrapTable, TableHeaderColumn as TableHead } from "react-bootstrap-table";
import {OverlayTrigger, Tooltip, Popover} from "react-bootstrap";
import ProfilePhoto from "../../../components/common/ProfilePhoto";
import axios from "axios";
import toastr from "toastr";

function columnClassNameFormat(fieldValue, row, rowIdx, colIdx) {
  switch (row.empStatus) {
    case 'I':
      return 'color3';
    case 'P':
      return 'color5';
    case  'A':
      return 'blue';
    default:
      return '';
  }
}
class AbscondTable extends React.Component {

  constructor() {
    super();
    this.state = {};
  }

  renderShowsTotal(start, to, total) {
    return (
      <p style={ {color: 'black'} }>
        From { start } to { to }, total entries { total }
      </p>
    );
  }

  checkNull(cell, row, formatExtraData, rowIdx) {
    if (cell == null || cell == undefined || cell == "") {
      return 'NA';
    }
    else return cell;
  }


  render() {

    const nameMapping = {
      empId: "ID",
      email: "E-Mail",
      fullName: "Full Name",
      joiningDate: "Date Of Joining",
      lastWorkingDay: "Last Working Day",
      managerId: "Reporting To",
      empStatus: "Status",
      abscondedFrom: "Absconded From",
      abscondedTo: "Absconded To",
      abscondedDay: "Absconded Day",
      exitDay: "Exit Day"
};
    const options = {
      clearSearch: true,
      sizePerPageList: [10, 20, 30, 40, 200],
      paginationShowsTotal: this.renderShowsTotal
    };
    return (
      <div>
        <BootstrapTable
        containerStyle={{borderBottomStyle: 'solid', borderColor: '#428BCA', borderWidth: '1px'}}
        headerStyle={{
          borderTopStyle: 'solid', borderTopColor: 'rgb(92, 184, 92)', borderWidth: '1px'
          , borderBottomStyle: 'solid', borderBottomColor: '#428BCA'
        }}
        options={options}
        tableStyle={{marginBottom: '5%', borderStyle: 'solid'}}
        data={this.props.employees}
        pagination
        >
          <TableHeaderColumn
            dataFormat = {(cell,row) => {
            var abscondDayCount = row.abscondDayCount;
             if(abscondDayCount<7){
              return(
                <div>
                <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip">Revert from abscond</Tooltip>}>
                  <img
                    style={{cursor: 'pointer'}}
                    onClick={()=> {
                      let flag = confirm('Are you sure ?');
                      if(flag == true) {
                        axios.post(process.env.REQ_URL + "/managerReject", {data: {empId: row.empId,type:"abscond"}}, {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
                                 toastr.success("Reverted From Abscond Successfully");
                                 this.props.refresh();
                        }).catch((error) => {
                                 console.log(error);
                        });
                      }
                    }}
                    src="/public/images/undo.png" width = "24px"></img>
                  </OverlayTrigger>
                  </div>);
              }
              else if(window.location.href.indexOf("teamAbsconds")>-1){
              return (<div>
              <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip">Move To Exit</Tooltip>}>
                  <img
                      onClick={()=> {
                      let flag = confirm('Are you sure ?');
                      if(flag == true) {
                        console.log(104,row.empStatus);
                        if(row.empStatus=="AB"){
                          this.props.moveToExitConfirm(row.empId);
                        }
                        else if (row.empStatus == "H") {
                          this.props.moveToExit( row.empId,row.fullName,row.abscondedFrom);
                        }
                      }
                    }}
                      style={{cursor: 'pointer'}}
                      src="/public/images/success.png"></img>
              </OverlayTrigger>
              <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip">Revert from abscond</Tooltip>}>
                <img
                  style={{cursor: 'pointer'}}
                  onClick={()=> {
                    let flag = confirm('Are you sure ?');
                    if(flag == true) {
                      axios.post(process.env.REQ_URL + "/managerReject", {data: {empId: row.empId,type:"abscond"}}, {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
                               toastr.success("Reverted From Abscond Successfully");
                               this.props.refresh();
                      }).catch((error) => {
                               console.log(error);
                      });
                    }
                  }}
                src="/public/images/undo.png" width = "24px"></img>
              </OverlayTrigger>
              </div>);
             }
             else if(row.empStatus=="H"){
              return (<div>
              <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip">Move To Exit</Tooltip>}>
                  <img
                      onClick={()=> {
                      let flag = confirm('Are you sure ?');
                      if(flag == true) {
                        if(row.empStatus=="AB"){
                          this.props.moveToExitConfirm(row.empId);
                        }
                        else if (row.empStatus == "H") {
                          this.props.moveToExit(row.empId,row.fullName,row.abscondedFrom);
                        }
                      }
                    }}
                      style={{cursor: 'pointer'}}
                      src="/public/images/success.png"></img>
              </OverlayTrigger>
              <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip">Revert from abscond</Tooltip>}>
                <img
                  style={{cursor: 'pointer'}}
                  onClick={()=> {
                    let flag = confirm('Are you sure ?');
                    if(flag == true) {
                      axios.post(process.env.REQ_URL + "/managerReject", {data: {empId: row.empId,type:"abscond"}}, {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
                               toastr.success("Reverted From Abscond Successfully");
                               this.props.refresh();
                      }).catch((error) => {
                               console.log(error);
                      });
                    }
                  }}
                src="/public/images/undo.png" width = "24px"></img>
              </OverlayTrigger>
              </div>);
             }
             else{
              return(
                <div>
                <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip">Revert from abscond</Tooltip>}>
                  <img
                    style={{cursor: 'pointer'}}
                    onClick={()=> {
                      let flag = confirm('Are you sure ?');
                      if(flag == true) {
                        axios.post(process.env.REQ_URL + "/managerReject", {data: {empId: row.empId,type:"abscond"}}, {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
                                 toastr.success("Reverted From Abscond Successfully");
                                 this.props.refresh();
                        }).catch((error) => {
                                 console.log(error);
                        });
                      }
                    }}
                    src="/public/images/undo.png" width = "24px"></img>
                  </OverlayTrigger>
                  </div>);
                  }
           } }
           dataField="empId">Action
          </TableHeaderColumn>
          <TableHeaderColumn
          isKey={true}
          filter={ {type: 'NumberFilter', delay: 0, placeholder: 'Employee Id'} }
          columnClassName={ columnClassNameFormat }
          dataField="empId">Emp Id
          </TableHeaderColumn>
          <TableHeaderColumn
          columnClassName={ columnClassNameFormat }
           dataField="email">Email Id
          </TableHeaderColumn>
          <TableHeaderColumn
          columnClassName={ columnClassNameFormat }
           dataField="empStatus">Emp<br/> Status
          </TableHeaderColumn>
          <TableHeaderColumn
          columnClassName={ columnClassNameFormat }
          filter={ {type: 'TextFilter', delay: 0, placeholder: 'Full Name'} }
           dataField="fullName">Full Name
          </TableHeaderColumn>
          <TableHeaderColumn
          columnClassName={ columnClassNameFormat }
           dataField="joiningDate">Joining<br/> Date
          </TableHeaderColumn>
          <TableHeaderColumn
          columnClassName={ columnClassNameFormat }
           dataField="lastWorkingDay"
             width={120}>Last Working <br/>Day
          </TableHeaderColumn>
          <TableHeaderColumn
          columnClassName={ columnClassNameFormat }
           dataField="abscondedFrom" 
           width={120}>Abandoned<br/> From
          </TableHeaderColumn>
          <TableHeaderColumn
          columnClassName={ columnClassNameFormat }
           dataField="abscondedTo"
           width={120}>Abandoned<br/> To
          </TableHeaderColumn>
          <TableHeaderColumn
          columnClassName={ columnClassNameFormat }
           dataField="abscondedDay"
           width={120}>Abandoned<br/> Day
          </TableHeaderColumn>
          <TableHeaderColumn
          columnClassName={ columnClassNameFormat }
           dataField="managerId">Manager<br/> Id
          </TableHeaderColumn>

        </BootstrapTable>

      </div>
    );
  }
}

AbscondTable.propTypes = {};

export default AbscondTable;





/** WEBPACK FOOTER **
 ** ./src/feature/hradmin/abscond/AbscondTable.js
 **/